<template>
  <div class="td-home">
    <NavbarView />
    <ParticlesBackgroundView />
    <h1 class="td-home-title">PERSONAL TOUCHDESIGNER PROJECTS AND STUFFS</h1>

    <div class="td-home-subtitle-container">
      <p class="td-home-subtitle">
        Here you can find <strong>personal projects</strong> and staffs made with TouchDesigner. All this is made in my free time for no particular purpose, just chilling and learning.
        You can find my <strong>YouTube channel</strong> where I sometimes post tutorials and breakdowns of some of these projects.
      </p>

      <a
        href="https://www.youtube.com/@TommasoRamella-n6n9h"
        target="_blank"
        rel="noopener noreferrer"
        class="youtube-image-button"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/0/09/YouTube_full-color_icon_(2017).svg"
          alt="YouTube channel"
        />
      </a>
    </div>

    <div class="td-video-container">
      <div class="td-row">
        <div class="td-column">
			<p class="td-label">DATA VISUALIZATION</p>
      <p> Data visualization tutorials and plots made with TouchDesigner</p>
			<router-link :to="{ name: 'data-viz' }">
        <video
          class="td-video"
          :src="dataViz"
          muted
          autoplay
          loop
          playsinline
          alt="Data visualization Projects"           
            />
          </router-link>
        </div>

        <div class="td-column">
          <p class="td-label">VISUALS/VJ</p>
          <router-link :to="{ name: 'visuals' }">
            <video
              :src="visuals"
              muted
              autoplay
              loop
              playsinline
              alt="Visuals and staffs"
              class="td-video"
            />
          </router-link>
          
        <div class="td-column">
          <p class="td-label">OTHER NONSENSE</p>
          <router-link :to="{ name: 'other' }">
            <video
            :src="other"
              muted
              autoplay
              loop
              playsinline
              alt="Other"
              class="td-video"
            />
          </router-link>
          </div>  

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import NavbarView from '../NavbarView.vue';
import ParticlesBackgroundView from '../ParticlesBackgroundView.vue';

export default {
  name: 'TdHome-View',
  components: {
    NavbarView,
    ParticlesBackgroundView
  },
	data() {
	return {
		dataViz: 'https://f003.backblazeb2.com/file/tommella-website-storage/td/dataViz/videos/top1Short.mov',
		visuals: 'https://f003.backblazeb2.com/file/tommella-website-storage/td/visuals/TrppyTunnel.mov',
		other: 'https://f003.backblazeb2.com/file/tommella-website-storage/td/other/mediapipe.mov',
	};
	}
}
</script>

<style scoped>
.art-home-title {
  text-align: center;
  color: #176219;
  font-size: 2.5em;
  margin-top: 100px;
}

.td-video-container {
  padding: 20px;
  text-align: center;
}

.td-video {
  width: 500px;
  height: 400px;
  object-fit: contain; /* crop to fill box, no distortion */
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* optional: for polish */
}

.td-home-subtitle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin: 30px auto 50px;
  max-width: 900px;
}

.td-home-subtitle {
  font-size: 1.2em;
  line-height: 1.6;
  color: #333;
  max-width: 650px;
}

.td-home-title {
  text-align: center;
  color: #176219;
  font-size: 2.5em;
  font-weight: bold;
  margin-top: 100px;
}

.td-label {
  text-align: center;
  color: #000000;
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 10px;
}

.youtube-image-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 70px;
  background: #ffffff;
  border: 2px solid #000000;
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.youtube-image-button img {
  width: 48px;
  height: auto;
  filter: grayscale(50%) brightness(70%); /* makes icon black */
}

.youtube-image-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
}


</style>




